var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription, of, throwError } from 'rxjs';
import { tap, map, takeUntil, retryWhen, delay, concatMap } from 'rxjs/operators';
import { Router } from '@angular/router';
// model
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { SearchService } from 'src/app/shared/service/search/search.service';
import { DetailPageInfo } from '../../model/detail-page-info.model';
import { SearchPage } from '../../model/search-page.model';
import { RequestManagerService } from 'src/app/shared/service/request-manager.service';
import * as i0 from "@angular/core";
import * as i1 from "../http-header.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../request-manager.service";
import * as i4 from "@angular/router";
var SearchWorkerProjectService = /** @class */ (function (_super) {
    __extends(SearchWorkerProjectService, _super);
    function SearchWorkerProjectService(header, http, requestManager, router, injector) {
        var _this = _super.call(this, header, http, requestManager, injector) || this;
        _this.router = router;
        _this.subscriptions = new Subscription();
        // サービス毎に初期値を設定する
        _this.initPage = { page: 1 };
        _this.initPerPage = { perPage: 10 };
        _this.selfServiceName = 'SearchWorkerProjectService';
        return _this;
    }
    SearchWorkerProjectService.prototype.ngOnDestroy = function () {
        this.subscriptions.unsubscribe();
    };
    SearchWorkerProjectService.prototype.doSearch = function (id, detailPageInfo) {
        // 前のリクエストをキャンセル
        this.requestManager.cancelRequest('search');
        this.currentSearchRequest$.next();
        this.setSearchPage(new SearchPage({ page: 1 }));
        detailPageInfo = new DetailPageInfo(detailPageInfo);
        var searchParams = this.getSearchParameters(detailPageInfo.getParams());
        var url = 'api/v1/workers/' + id + '/projects';
        return _super.prototype.requestPost.call(this, url, searchParams).pipe(takeUntil(this.currentSearchRequest$), // リクエストキャンセル用
        tap({
            next: function (response) {
                // 成功時のログ出力を削減
            },
            error: function (error) {
                // エラー時のログ出力を削減（重要なエラーのみ出力）
                if (error.status === 401) {
                    console.error('Authentication error:', error.status);
                }
            }
        }));
    };
    SearchWorkerProjectService.prototype.showWorkerMail = function (id) {
        var _this = this;
        var url = 'api/v1/workers/' + id;
        return _super.prototype.requestGet.call(this, url).pipe(
        // リトライ機能を追加（2回までリトライ）
        retryWhen(function (errors) {
            return errors.pipe(concatMap(function (error, index) {
                // 404エラーまたは500エラー（validate_table_name_for_userエラー）の場合のみリトライ
                if ((error.status === 404 || error.status === 500) && index < 2) {
                    console.warn("\u30EF\u30FC\u30AB\u30FC\u30E1\u30FC\u30EB\u53D6\u5F97\u304C\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u30EA\u30C8\u30E9\u30A4 " + (index + 1) + "/2:", error);
                    return of(error).pipe(delay(1000)); // 1秒待機してリトライ
                }
                // 2回失敗した場合、または対象外エラーの場合はエラーを投げる
                if ((error.status === 404 || error.status === 500) && index >= 2) {
                    console.error('ワーカーメール取得が2回失敗しました。エラーメッセージを表示します。');
                    _this.showErrorToast();
                }
                return throwError(error);
            }));
        }));
    };
    SearchWorkerProjectService.prototype.showProjectMail = function (id) {
        var url = 'api/v1/projects/' + id;
        return _super.prototype.requestGet.call(this, url);
    };
    SearchWorkerProjectService.prototype.getSearchParameters = function (detailPageInfo) {
        var condition = this.getSearchCondition().getParams();
        var count = this.getSearchCount().getParams();
        var page = this.getSearchPage().getParams();
        var searchTags = { search_tag_ids: this.getSearchTagIds() };
        return Object.assign(condition, count, page, searchTags, detailPageInfo);
    };
    SearchWorkerProjectService.prototype.getTransitionPage = function (id, direction) {
        var params = { id: id, direction: direction };
        return _super.prototype.requestGet.call(this, 'api/v1/workers/page_transition', params);
    };
    SearchWorkerProjectService.prototype.transitionPage = function (id, direction) {
        var _this = this;
        var observable;
        if (sessionStorage.workerIds) {
            observable = new Observable(function (observer) {
                observer.next(_this.getNextmailIdFromSession(id, direction));
            });
        }
        else {
            observable = this.getTransitionPage(id, direction).pipe(map(function (res) { return res.body.worker.id; }));
        }
        var transitionSub = observable.subscribe(function (mailId) {
            if (mailId) {
                _this.router.navigate(['/matching/workers/' + mailId]);
            }
        });
        this.subscriptions.add(transitionSub);
    };
    SearchWorkerProjectService.prototype.getNextmailIdFromSession = function (id, direction) {
        var nexttMailId;
        var workerIds = sessionStorage.workerIds.split(',');
        var indexOfCurrentMail = workerIds.indexOf(id);
        if (direction === 'next') {
            nexttMailId = workerIds[indexOfCurrentMail + 1];
        }
        else {
            nexttMailId = workerIds[indexOfCurrentMail - 1];
        }
        return nexttMailId;
    };
    SearchWorkerProjectService.ngInjectableDef = i0.defineInjectable({ factory: function SearchWorkerProjectService_Factory() { return new SearchWorkerProjectService(i0.inject(i1.HttpHeaderService), i0.inject(i2.HttpClient), i0.inject(i3.RequestManagerService), i0.inject(i4.Router), i0.inject(i0.INJECTOR)); }, token: SearchWorkerProjectService, providedIn: "root" });
    return SearchWorkerProjectService;
}(SearchService));
export { SearchWorkerProjectService };
